import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { AuthService } from '../../../services/auth/auth.service';

@Component({
  selector: 'app-logout-callback',
  templateUrl: './logout-callback.component.html',
  styleUrls: ['./logout-callback.component.css'],
  standalone: false
})
export class LogoutCallbackComponent implements OnInit {
  constructor(private oauthService: OAuthService, private router: Router, private authService: AuthService) {}

  ngOnInit(): void {
    try {
      // Best-effort cleanup of any app-side session storage
      sessionStorage.removeItem('access_token');
      sessionStorage.removeItem('oaccess_token');
      sessionStorage.removeItem('OfflineModeEnabled');
      sessionStorage.removeItem('token');
    } catch {}

    // Redirect after short delay
    setTimeout(() => {
      this.router.navigate(['/splash']);
    }, 2500);
  }

  loginAgain(): void {
    this.authService.login();
  }
}
